import { isPlatformBrowser } from "@angular/common";
import { Component, Inject, OnInit, Optional, PLATFORM_ID, RESPONSE_INIT } from '@angular/core';
import { RESPONSE } from "../../express.tokens";
import { Response } from 'express';

@Component({
    selector: 'gea-shop-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit {
constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private response?: Response,
    @Optional() @Inject(RESPONSE_INIT) private responseInit?: ResponseInit | null,
  ) {
  }
  ngOnInit() {
    if (! isPlatformBrowser(this.platformId)) {
      const currentStatus = this.responseInit?.status ?? this.response?.statusCode
      if (currentStatus && currentStatus >= 500) return

      this.response?.status(404)
      if (this.responseInit) {
        this.responseInit.status = 404
      }
    }
  }
}
